/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/medals.js';


class MedalsStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.accountMedals = [];
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.UPDATE_ACCOUNT_MEDALS:
                this.accountMedals = action.response;
                this.emitChange();
                break;
            case Constants.UPDATE_CLASS_MEDALS_LEVEL:
                this.classMedals   = action.response;
                this.emit('UPDATE_CLASS_MEDALS_LEVEL');
                break;
            case Constants.UPDATE_STUDENT_MEDALS_TOTAL:
                this.studentMedals   = action.response;
                this.emit('UPDATE_STUDENT_MEDALS_TOTAL');
                break;
        }

    }


    getAccountGold(){
        for(var idx = 0 ; idx < this.accountMedals.length; idx++)
            if(this.accountMedals[idx].medal == 'gold') return this.accountMedals[idx].number

        return 0
    }

    getAccountBronze(){
        for(var idx = 0 ; idx < this.accountMedals.length; idx++)
            if(this.accountMedals[idx].medal == 'bronze') return this.accountMedals[idx].number

        return 0
    }

    getAccountSilver(){
        for(var idx = 0 ; idx < this.accountMedals.length; idx++)
            if(this.accountMedals[idx].medal == 'sliver') return this.accountMedals[idx].number

        return 0
    }


    getClassGold(){
        for(var idx = 0 ; idx < this.classMedals.length; idx++)
            if(this.classMedals[idx].medal == 'gold') return this.classMedals[idx].number

        return 0
    }

    getClassBronze(){
        for(var idx = 0 ; idx < this.classMedals.length; idx++)
            if(this.classMedals[idx].medal == 'bronze') return this.classMedals[idx].number

        return 0
    }

    getClassSilver(){
        for(var idx = 0 ; idx < this.classMedals.length; idx++)
            if(this.classMedals[idx].medal == 'sliver') return this.classMedals[idx].number

        return 0
    }


    getStudentGold(){
        for(var idx = 0 ; idx < this.studentMedals.length; idx++)
            if(this.studentMedals[idx].medal == 'gold') return this.studentMedals[idx].number

        return 0
    }

    getStudentBronze(){
        for(var idx = 0 ; idx < this.studentMedals.length; idx++)
            if(this.studentMedals[idx].medal == 'bronze') return this.studentMedals[idx].number

        return 0
    }

    getStudentSilver(){
        for(var idx = 0 ; idx < this.studentMedals.length; idx++)
            if(this.studentMedals[idx].medal == 'sliver') return this.studentMedals[idx].number

        return 0
    }



}

export default new MedalsStore();


// WEBPACK FOOTER //
// ./src/store/medals-store.js